import { DueDateInputFieldParams, EnumData, EnumValue, Expr, InputFieldParams, PrimitiveData, RadioInputParams, ResourceValueWithKind, SelectAccountFieldParams, SelectFieldParams, SimpleResourceValue, } from "../Types";
export const isResolvedResource = (resource) => {
    return (SimpleResourceValue.safeParse(resource).success ||
        ResourceValueWithKind.safeParse(resource).success);
};
export const isEnumValue = (value) => {
    return EnumValue.safeParse(value).success;
};
export const isExpr = (value) => {
    return Expr.safeParse(value).success;
};
// === Field Data Type Guards ===
export const isEnumData = (dataType) => {
    return EnumData.safeParse(dataType).success;
};
export const isPrimitiveData = (dataType) => {
    return PrimitiveData.safeParse(dataType).success;
};
export const hasDataType = (fieldParameter) => {
    return fieldParameter.dataType !== undefined;
};
export const hasEnumData = (fieldParameter) => {
    return hasDataType(fieldParameter) && isEnumData(fieldParameter.dataType);
};
export const hasPrimitiveData = (fieldParameter) => {
    return (hasDataType(fieldParameter) && isPrimitiveData(fieldParameter.dataType));
};
// === Field Display Type Guards ===
export const isSelectField = (display) => {
    return SelectFieldParams.safeParse(display).success;
};
export const isInputField = (display) => {
    return InputFieldParams.safeParse(display).success;
};
export const isSelectAccountField = (display) => {
    return SelectAccountFieldParams.safeParse(display).success;
};
export const isDueDateInputField = (display) => {
    return DueDateInputFieldParams.safeParse(display).success;
};
export const isRadioInputField = (display) => {
    return RadioInputParams.safeParse(display).success;
};
// === Declarative Field Analysis using existing schema types ===
export const isSelectableField = (fieldParameter) => {
    const { display } = fieldParameter;
    return (isSelectField(display) ||
        isSelectAccountField(display) ||
        isRadioInputField(display));
};
export const requiresOptions = (fieldParameter) => {
    return hasEnumData(fieldParameter) && isSelectableField(fieldParameter);
};
//# sourceMappingURL=guards.js.map